import { css, keyframes } from 'styled-components';

import {
  motionEasingEnter,
  motionEasingLeave,
  motionTimeS,
  spaceS,
} from '@xing-com/tokens';

// *** Keyframes ***
export const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

export const slideUpIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(${spaceS});
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const slideDownIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-${spaceS});
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const slideLeftIn = keyframes`
  from {
    opacity: 0;
    transform: translateX(${spaceS});
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const slideRightIn = keyframes`
  from {
    opacity: 0;
    transform: translateX(-${spaceS});
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const slideUpOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(-${spaceS});
  }
`;

export const slideDownOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(${spaceS});
  }
`;

export const slideLeftOut = keyframes`
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(-${spaceS});
  }
`;

export const slideRightOut = keyframes`
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(${spaceS});
  }
`;

// *** Arrow Animation ***
export const arrowAnimation = css`
  &[data-state='open'] {
    animation: ${fadeIn} ${motionTimeS} ${motionEasingEnter} forwards;
  }
  &[data-state='closed'] {
    animation: ${fadeOut} ${motionTimeS} ${motionEasingLeave} forwards;
  }
`;
